const initialState = {
  data: [],
  total: 0, // Total de registros
  pagination: {
    page: 1, // Página actual
    perPage: 10 // Registros por página
  }
}

const egresosReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_EGRESOS':
      //console.log("Datos guardados en Redux:", action.data)
      return {
        ...state,
        data: action.data.data, // Los datos de la página actual
        total: action.data.total, // Total de registros
        pagination: {
          ...state.pagination,
          page: action.data.page, // Página actual
          perPage: action.data.perPage // Registros por página
        }
      }
    case 'ADD_EGRESO':
      return {
        ...state,
        data: [action.egreso, ...state.data], // Agrega el nuevo egreso al principio de la lista
        total: state.total + 1 // Incrementa el total de registros
      }
    default:
      return state
  }
}

const ingresosReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_INGRESOS':
      //console.log("Datos guardados en Redux:", action.data)
      return {
        ...state,
        data: action.data.data, 
        total: action.data.total, 
        pagination: {
          ...state.pagination,
          page: action.data.page, 
          perPage: action.data.perPage 
        }
      }
    case 'ADD_INGRESO':
      return {
        ...state,
        data: [action.ingreso, ...state.data],
        total: state.total + 1 
      }
    default:
      return state
  }
}

export default  { egresosReducer, ingresosReducer }